angular.module('tgaAdmin').directive('uiNav', () => ({
  restrict: 'AC',
  link(scope, el) {
    el.find('a').on('click', function () {
      const li = angular.element(this).parent();
      const active = li.parent()[0].querySelectorAll('.active');
      li.toggleClass('active');
      angular.element(active).removeClass('active');
    });
  },
}));
